import { request, makePath } from './http';
const API_NAME = 'billing';

export const STATUS_ACTIVE = 'Active';
export const STATUS_CANCELED = 'Canceled';
export const STATUS_EXPIRED = 'Expired';
export const STATUS_PAST_DUE = 'PastDue';
export const STATUS_PENDING = 'Pending';
export const STATUS_NONE = 'None';

// this version is unauthenticated, and generates a token for a new braintree customer
// created specifically for this operation.  It returns {customer_id, client_token}.
export function getClientToken({anonymous=false}) {
  return request('GET', makePath(API_NAME, 'clienttoken'), {params:{anonymous}});
}

// this version is authenticated, and generates a token for the braintree customer
// associated with the provider (creating one if none exists).
export function getProviderClientToken(providerUuid) {
  return request('GET', makePath(API_NAME, 'clienttoken', providerUuid));
}

export function getPaymentMethods(providerUuid) {
  return request('GET', makePath(API_NAME, 'paymentmethod', providerUuid));
}

export function selectPaymentMethod(providerUuid, paymentMethodToken) {
  return request('PUT', makePath(API_NAME, 'paymentmethod', providerUuid, paymentMethodToken));
}

export function addPaymentMethod(providerUuid, paymentMethodNonce, makeDefault) {
  return request('POST', makePath(API_NAME, 'paymentmethod', providerUuid, paymentMethodNonce), { params: {makeDefault} });
}

export function deletePaymentMethod(providerUuid, paymentMethodToken) {
  return request('DELETE', makePath(API_NAME, 'paymentmethod', providerUuid, paymentMethodToken));
}

export function getPlans() {
  return request('GET', makePath(API_NAME, 'plans'));
}

export function getSubscription(providerUuid) {
  return request('GET', makePath(API_NAME, 'subscription', providerUuid));
}

export function cancelSubscription(providerUuid) {
  return request('DELETE', makePath(API_NAME, 'subscription', providerUuid));
}
